export default __webpack_public_path__ + "static/media/img11.99db1d3e.jpg";